import * as R from 'ramda';

export const mapEligibilityOperators = (payload) =>
  payload.map(({ displayName, name, allowsMultipleSelect }) => ({
    value: name,
    label: displayName,
    allowsMultipleSelect,
  }));

export const mapSystemVariables = (payload) =>
  R.sortBy(
    R.prop('value'),
    payload.map(({ displayName, propertyName, type, valuesUrl }) => ({
      value: propertyName,
      label: displayName,
      type,
      valuesUrl,
    }))
  );

export const processPopulationChange = (statePopulations, payload) => {
  const populations = statePopulations;

  populations[payload.index] = {
    ...populations[payload.index],
    [payload.field]: payload.value,
    ...payload.other,
  };

  return populations;
};

export const getLookupData = (lookupData, url) => ({
  [url]: R.sortBy(R.prop('value'), (lookupData || []).map((item) => ({ label: item, value: item }))),
});
